<template>
  <a-modal
    v-if="visible"
    title="Filters"
    width="600px"
    :visible="visible"
    :destroy-on-close="true"
    @cancel="cancel"
  >
    <div class="grid">
      <template v-if="showAssociateFilter">
        <b class="col-4">Associate</b>
        <table-associate-search
          class="col-8"
          :filters.sync="filters"
          filter-key="associate_id"
          :is-associate-id="true"
          :multiply="false"
          :use-router="false"
          data-testid="disciplinary-actions-filter-associate"
        />
      </template>

      <b class="col-4">Start Date</b>
      <a-date-picker
        ref="startDatePicker"
        v-model="filters.start_date"
        class="col-8"
        format="MM/DD/YYYY"
        value-format="YYYY-MM-DD"
        placeholder="Start Date"
        @change="handleStartDateChange('start_date', 'end_date')"
      />

      <b class="col-4">End Date</b>
      <a-date-picker
        ref="endDatePicker"
        v-model="filters.end_date"
        class="col-8"
        format="MM/DD/YYYY"
        value-format="YYYY-MM-DD"
        placeholder="End Date"
        :open="isEndDatePickerOpen"
        :default-picker-value="getEndDateDefaultPickerValue('start_date')"
        @change="handleEndDateChange('start_date', 'end_date')"
        @openChange="handleEndDateOpenChange"
      />

      <b class="col-4">Disciplinary Actions</b>
      <custom-select
        class="col-8"
        :multiple="true"
        :value.sync="filters.types"
        placeholder="Disciplinary Actions"
        :options="actionTypes"
        name="label"
        option-key="value"
        data-testid="disciplinary-actions-filter-types"
      />
    </div>

    <template slot="footer">
      <div class="flex justify-content-end">
        <a-button type="danger" :disabled="isEmptyFilters" @click="reset">Reset</a-button>
        <a-button type="primary" @click="apply">Apply</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import { Button, DatePicker, Modal } from 'ant-design-vue'
import CustomSelect from '@/components/ui/custom-select.vue'
import TableAssociateSearch from '@/components/entities/table/table-associate-search.vue'
import LinkedDateFilterMixin from '@/mixins/linkedDateFilterMixin'
import { deepCopy } from '@/utils/deep-copy'

const filtersBaseState = Object.freeze({
  associate_id: undefined,
  start_date: undefined,
  end_date: undefined,
  types: []
})

export default {
  components: {
    'a-modal': Modal,
    'a-button': Button,
    'a-date-picker': DatePicker,
    'custom-select': CustomSelect,
    'table-associate-search': TableAssociateSearch
  },
  mixins: [LinkedDateFilterMixin],
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    currentFilters: {
      type: Object,
      required: true
    },
    showAssociateFilter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      filters: deepCopy(filtersBaseState),
      actionTypes: [
        { value: 'block', label: 'Block' },
        { value: 'write_up', label: 'Write-Up' },
        { value: 'suspension', label: 'Suspension' }
      ]
    }
  },
  computed: {
    isEmptyFilters() {
      const visibleBaseState = this.showAssociateFilter
        ? filtersBaseState
        : { ...filtersBaseState, associate_id: this.filters.associate_id }

      return JSON.stringify(visibleBaseState) === JSON.stringify(this.filters)
    }
  },
  watch: {
    visible: {
      handler(value) {
        if (!value) return

        this.filters = {
          ...deepCopy(filtersBaseState),
          ...deepCopy(this.currentFilters),
          types: [...(this.currentFilters.types ?? [])]
        }
      },
      immediate: true
    }
  },
  methods: {
    reset() {
      const filters = deepCopy(filtersBaseState)

      if (!this.showAssociateFilter) {
        filters.associate_id = this.currentFilters.associate_id
      }

      this.filters = filters
      this.$emit('update:currentFilters', filters)
    },
    cancel() {
      this.$emit('update:visible', false)
    },
    apply() {
      this.$emit('update:currentFilters', this.filters)
      this.cancel()
    }
  }
}
</script>

<style scoped>
.ant-calendar-picker {
  margin: 0;
}
</style>
